var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "container"
  }, [_vm.showCommentBack ? _c("div", {
    staticClass: "top-wrap"
  }) : _vm._e(), _vm.showCommentBack ? _c("div", {
    staticClass: "titleBar"
  }, [_c("div", {
    staticClass: "img-wrap",
    on: {
      click: _vm.back
    }
  }, [_c("img", {
    attrs: {
      src: require("../../assets/images/arrow.png"),
      alt: ""
    }
  })]), _c("div", {
    staticClass: "center"
  }, [_vm._v(_vm._s(_vm.$t(_vm.title)))]), _c("div", {
    staticClass: "img-wrap"
  })]) : _vm._e(), _c("div", {
    staticClass: "wrap-container"
  }, [_c("div", {
    directives: [{
      name: "longpress",
      rawName: "v-longpress",
      value: _vm.longpress,
      expression: "longpress"
    }],
    staticClass: "commnets-item",
    on: {
      touchstart: function touchstart($event) {
        return _vm.start(_vm.commentData.userId, _vm.commentData.id);
      }
    }
  }, [_c("div", {
    staticClass: "user"
  }, [_c("div", {
    staticClass: "user-info"
  }, [_vm.commentData.user.avatar ? _c("img", {
    staticClass: "img",
    attrs: {
      src: _vm.commentData.user.avatar,
      alt: ""
    }
  }) : _c("img", {
    staticClass: "img",
    attrs: {
      src: require("../../assets/images/icon_avatar.png"),
      alt: ""
    }
  }), _c("div", {
    staticClass: "txt"
  }, [_c("span", {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.commentData.user.nickname))]), _c("span", {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.commentData.createdAt))])])]), _c("div", {
    staticClass: "comments-goods",
    on: {
      click: function click($event) {
        return _vm.thumbsUp(_vm.commentData.id, _vm.commentData.isLiked);
      }
    }
  }, [!_vm.commentData.isLiked ? _c("img", {
    attrs: {
      src: require("../../assets/images/ic_other_more_like.png"),
      alt: ""
    }
  }) : _c("img", {
    attrs: {
      src: require("../../assets/images/Like1.png"),
      alt: ""
    }
  }), _c("span", [_vm._v(_vm._s(_vm.commentData.likeCount))])])]), _c("span", {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.commentData.content) + " "), _vm.commentData.userId == _vm.storeUserId ? _c("img", {
    staticStyle: {
      "pointer-events": "auto !important",
      height: "5vw",
      width: "5vw",
      float: "right",
      "margin-right": "7vw",
      "z-index": "999"
    },
    attrs: {
      src: require("../../assets/images/comment_del.png")
    },
    on: {
      click: function click($event) {
        return _vm.delComments();
      }
    }
  }) : _vm._e()])]), _c("div", {
    staticClass: "con"
  }, [_c("h4", {
    staticClass: "latest"
  }, [_vm._v(_vm._s(_vm.$t("LatestComments")))]), _c("div", {
    staticClass: "comments-con"
  }, [_vm.commentData.commentPosts.length > 0 ? _c("div", {
    staticClass: "reply-con"
  }, _vm._l(_vm.commentData.commentPosts, function (itm) {
    return _c("div", {
      key: itm.id,
      class: ["reply-item", {
        selected: itm.isSelected
      }],
      on: {
        touchstart: function touchstart($event) {
          return _vm.start(itm.userId, itm.id, itm);
        }
      }
    }, [_c("div", {
      staticClass: "user"
    }, [_c("div", {
      staticClass: "user-info",
      on: {
        click: function click($event) {
          return _vm.toReply(itm.user.nickname, _vm.commentData.id, itm.id);
        }
      }
    }, [itm.user.avatar ? _c("img", {
      staticClass: "img",
      attrs: {
        src: itm.user.avatar,
        alt: ""
      }
    }) : _c("img", {
      staticClass: "img",
      attrs: {
        src: require("../../assets/images/icon_avatar.png"),
        alt: ""
      }
    }), _c("div", {
      staticClass: "txt"
    }, [_c("span", {
      staticClass: "name"
    }, [_vm._v(_vm._s(itm.user.nickname))]), _c("span", {
      staticClass: "date"
    }, [_vm._v(_vm._s(itm.createdAt))])])]), _c("div", {
      staticClass: "comments-goods",
      on: {
        click: function click($event) {
          return _vm.thumbsUp(itm.id, itm.isLiked);
        }
      }
    }, [!itm.isLiked ? _c("img", {
      attrs: {
        src: require("../../assets/images/ic_other_more_like.png"),
        alt: ""
      }
    }) : _c("img", {
      attrs: {
        src: require("../../assets/images/Like1.png"),
        alt: ""
      }
    }), _c("span", [_vm._v(_vm._s(itm.likeCount))])])]), _c("div", {
      staticClass: "last-reply"
    }, [itm.commentUser ? _c("span", [_vm._v(_vm._s(_vm.$t("rely")))]) : _vm._e(), _vm._v(" "), itm.commentUser ? _c("span", {
      staticClass: "name"
    }, [_vm._v(_vm._s(itm.commentUser.nickname))]) : _vm._e(), itm.commentUser ? _c("span", [_vm._v(" : ")]) : _vm._e(), _c("span", {
      on: {
        click: function click($event) {
          return _vm.toReply(itm.user.nickname, _vm.commentData.id, itm.id);
        }
      }
    }, [_vm._v(_vm._s(itm.content))]), itm.userId == _vm.storeUserId ? _c("img", {
      staticStyle: {
        "pointer-events": "auto !important",
        height: "5vw",
        width: "5vw",
        float: "right",
        "margin-right": "7vw"
      },
      attrs: {
        src: require("../../assets/images/comment_del.png")
      },
      on: {
        click: function click($event) {
          return _vm.delComments();
        }
      }
    }) : _vm._e()])]);
  }), 0) : _vm._e()])])]), _c("van-popup", {
    style: {
      height: "200px",
      zIndex: 99999
    },
    attrs: {
      position: "bottom"
    },
    model: {
      value: _vm.show,
      callback: function callback($$v) {
        _vm.show = $$v;
      },
      expression: "show"
    }
  }, [_c("div", {
    staticClass: "pop"
  }, [_c("span", {
    on: {
      click: _vm.del
    }
  }, [_vm._v(_vm._s(_vm.$t("delete")))]), _c("span", {
    on: {
      click: _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t("cancel")))])])]), _c("div", {
    staticClass: "input-con"
  }, [_c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.inputValue,
      expression: "inputValue"
    }],
    ref: "inputs",
    attrs: {
      type: "text",
      placeholder: _vm.$t(_vm.placeholder)
    },
    domProps: {
      value: _vm.inputValue
    },
    on: {
      input: [function ($event) {
        if ($event.target.composing) return;
        _vm.inputValue = $event.target.value;
      }, function ($event) {
        return _vm.input(_vm.inputValue);
      }],
      focus: _vm.focus,
      blur: _vm.blur
    }
  }), _c("span", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isFocus,
      expression: "isFocus"
    }],
    class: ["send", {
      active: !_vm.isEmpty
    }],
    on: {
      click: _vm.send
    }
  }, [_vm._v(_vm._s(_vm.$t("send")))])]), _c("div", {
    staticClass: "bottom-box"
  }), _c("van-popup", {
    staticClass: "paymentExplainClass paymentExplainClass1",
    attrs: {
      round: ""
    },
    model: {
      value: _vm.confirmTextShow,
      callback: function callback($$v) {
        _vm.confirmTextShow = $$v;
      },
      expression: "confirmTextShow"
    }
  }, [_c("div", {
    staticClass: "paymentExplainContainer"
  }, [_c("div", {
    staticClass: "text"
  }, [_c("div", [_vm._v(" " + _vm._s(_vm.$t("pctdtc")) + " ")])]), _c("div", {
    staticClass: "popBtn"
  }, [_c("div", {
    staticClass: "okBtn canBtn",
    on: {
      click: _vm.cancelTextHandler
    }
  }, [_vm._v(_vm._s(_vm.$t("cancel")))]), _c("div", {
    staticClass: "okBtn conBtn",
    on: {
      click: _vm.confirmOKHandler
    }
  }, [_vm._v(_vm._s(_vm.$t("confirm")))])])])])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };